import { QuotesEvent, useQuotesStateShown } from '@/components/quotes/quotesAnalytics'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import type { InsuranceApplication } from '@/models/insuranceApplication'
import { ReviewConfirmation } from './ReviewConfirmation'

interface ReviewAttestationCardProps {
  application: InsuranceApplication
  /** Refetches the application; the quotes unblur once it says the customer confirmed. */
  onConfirmed: () => Promise<void>
  /** Their information is unblurred to check; the quotes stay blurred until they confirm. */
  informationShown: boolean
  onShowInformation: () => void
}

/** Sits over the blurred page until the customer confirms what their broker filled in. */
export function ReviewAttestationCard({
  application,
  onConfirmed,
  informationShown,
  onShowInformation,
}: ReviewAttestationCardProps) {
  useQuotesStateShown(QuotesEvent.REVIEW_ATTESTATION_SHOWN, true, {
    has_channel_pick: !!application.pendingChannelPick,
  })

  return (
    <Card asChild className="w-full max-w-xl shadow-lg">
      <section aria-labelledby="review-attestation-heading">
        <CardHeader>
          <CardTitle>
            <h2 id="review-attestation-heading" className="text-ink text-xl">
              Check your information
            </h2>
          </CardTitle>
          <CardDescription className="text-ink-600 text-base">
            {informationShown
              ? 'Your Cai broker filled this in from your documents. Check it above, then confirm to see your quotes.'
              : 'Your Cai broker filled in your application from your documents. Review it, then confirm to see your quotes.'}
          </CardDescription>
          {!informationShown && (
            <div>
              <Button type="button" variant="link" className="h-auto p-0" onClick={onShowInformation}>
                Review my information
              </Button>
            </div>
          )}
        </CardHeader>
        <CardContent>
          <ReviewConfirmation application={application} onConfirmed={onConfirmed} />
        </CardContent>
      </section>
    </Card>
  )
}
